import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducer/authReducer";

/** After any logout, send the user to the login screen (covers menu, session expiry, etc.). */
const redirectOnLogoutMiddleware = () => (next) => (action) => {
  const result = next(action);
  if (action.type === "auth/logout") {
    window.location.replace("/login");
  }
  return result;
};

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(redirectOnLogoutMiddleware),
});

export default store;
